import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=1e957f3f&"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports